// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".service-level[data-v-7eaccab3]{grid-area:service-level}", ""]);
// Exports
module.exports = exports;
